export default "__VITE_ASSET__CYLdi1gM__"